// src/config/advisorMissions.js
// Constantes du module Missions Art Advisor (spec §5, §12). Libellés FR.

export const MISSION_TYPES = [
  ["inventory", "Inventaire initial"],
  ["import_structuring", "Import et structuration"],
  ["valuation", "Valorisation"],
  ["condition_review", "Constat / suivi de conservation"],
  ["provenance_research", "Recherche de provenance"],
  ["acquisition_advice", "Conseil à l'acquisition"],
  ["sale_advice", "Conseil à la cession"],
  ["insurance_file", "Préparation assurance"],
  ["institutional_loan", "Prêt à une institution"],
  ["transport_logistics", "Transport et logistique"],
  ["restoration_coordination", "Coordination restauration"],
  ["succession_support", "Accompagnement à la transmission"],
  ["collection_transfer", "Transfert de collection vers un autre client"],
  ["collection_strategy", "Stratégie de collection"],
  ["curatorial_report", "Lecture / rapport curatorial"],
  ["other", "Autre"],
];

// value, label, tailwind color token
export const MISSION_STATUSES = [
  ["draft", "Brouillon", "gray"],
  ["proposed", "Proposée", "blue"],
  ["accepted", "Acceptée", "blue"],
  ["in_progress", "En cours", "amber"],
  ["waiting_client", "Attente client", "amber"],
  ["waiting_third_party", "Attente tiers", "amber"],
  ["ready_to_deliver", "Prête à livrer", "violet"],
  ["delivered", "Livrée", "green"],
  ["closed", "Clôturée", "green"],
  ["cancelled", "Annulée", "gray"],
];

export const PRIORITIES = [
  ["low", "Basse"],
  ["normal", "Normale"],
  ["high", "Haute"],
  ["urgent", "Urgente"],
];

export const TASK_STATUSES = [
  ["todo", "À faire"],
  ["in_progress", "En cours"],
  ["blocked", "Bloquée"],
  ["done", "Faite"],
  ["cancelled", "Annulée"],
];

export const DOC_STATUSES = [
  ["requested", "Demandé"],
  ["received", "Reçu"],
  ["validated", "Validé"],
  ["rejected", "Refusé"],
  ["not_applicable", "N/A"],
];

// Suivi de facture EXTERNE (§12.7)
export const EXTERNAL_BILLING_STATUSES = [
  ["not_applicable", "Sans objet"],
  ["to_invoice", "À facturer"],
  ["invoice_prepared", "Facture préparée"],
  ["invoice_sent", "Facture envoyée"],
  ["partially_paid", "Partiellement payée"],
  ["paid", "Payée"],
  ["overdue", "En retard"],
  ["cancelled", "Annulée"],
  ["credited", "Avoir émis"],
];

// Modes proposés dans l'UI pour une mission PROPRE (advisor_direct).
// artkiv_invoice = bêta (phase 2). artkiv_invoice_stripe_connected / artkiv_sold_service = phases ultérieures.
export const BILLING_MODES = [
  ["external", "Facturation externe (mon outil)"],
  ["artkiv_invoice", "Facturer avec ARTKIV (bêta)"],
  ["none", "Aucune facturation"],
];

export const labelOf = (list, value) => {
  const row = list.find((r) => r[0] === value);
  return row ? row[1] : value || "—";
};

// Traductions EN/DE des types et statuts (les libellés FR restent dans les tableaux).
const MISSION_TYPE_LABELS = {
  en: { collection_transfer: "Collection transfer to another client", inventory: "Initial inventory", import_structuring: "Import & structuring", valuation: "Valuation", condition_review: "Condition report / monitoring", provenance_research: "Provenance research", acquisition_advice: "Acquisition advice", sale_advice: "Sale advice", insurance_file: "Insurance preparation", institutional_loan: "Loan to an institution", transport_logistics: "Transport & logistics", restoration_coordination: "Restoration coordination", succession_support: "Transmission support", collection_strategy: "Collection strategy", curatorial_report: "Curatorial report", other: "Other" },
  de: { collection_transfer: "Sammlungsübertragung an einen anderen Kunden", inventory: "Erstinventar", import_structuring: "Import & Strukturierung", valuation: "Bewertung", condition_review: "Zustandsbericht / -überwachung", provenance_research: "Provenienzrecherche", acquisition_advice: "Ankaufsberatung", sale_advice: "Verkaufsberatung", insurance_file: "Versicherungsvorbereitung", institutional_loan: "Leihgabe an Institution", transport_logistics: "Transport & Logistik", restoration_coordination: "Restaurierungskoordination", succession_support: "Übertragungsbegleitung", collection_strategy: "Sammlungsstrategie", curatorial_report: "Kuratorischer Bericht", other: "Andere" },
};
const MISSION_STATUS_LABELS = {
  en: { draft: "Draft", proposed: "Proposed", accepted: "Accepted", in_progress: "In progress", waiting_client: "Waiting on client", waiting_third_party: "Waiting on third party", ready_to_deliver: "Ready to deliver", delivered: "Delivered", closed: "Closed", cancelled: "Cancelled" },
  de: { draft: "Entwurf", proposed: "Vorgeschlagen", accepted: "Angenommen", in_progress: "In Bearbeitung", waiting_client: "Warten auf Kunde", waiting_third_party: "Warten auf Dritte", ready_to_deliver: "Lieferbereit", delivered: "Geliefert", closed: "Abgeschlossen", cancelled: "Storniert" },
};
const langOf = (lang) => String(lang || "fr").slice(0, 2).toLowerCase();
export const missionTypeLabel = (value, lang) => {
  const l = langOf(lang);
  if (l === "fr") return labelOf(MISSION_TYPES, value);
  return (MISSION_TYPE_LABELS[l] || {})[value] || labelOf(MISSION_TYPES, value);
};
export const missionStatusLabel = (value, lang) => {
  const l = langOf(lang);
  if (l === "fr") return labelOf(MISSION_STATUSES, value);
  return (MISSION_STATUS_LABELS[l] || {})[value] || labelOf(MISSION_STATUSES, value);
};
export const statusColor = (value) => {
  const row = MISSION_STATUSES.find((r) => r[0] === value);
  return row ? row[2] : "gray";
};

// classes de badge par token de couleur
export const BADGE = {
  gray: "bg-gray-100 text-gray-600",
  blue: "bg-blue-100 text-blue-700",
  amber: "bg-amber-100 text-amber-700",
  violet: "bg-violet-100 text-violet-700",
  green: "bg-emerald-100 text-emerald-700",
  rose: "bg-rose-100 text-rose-700",
};
